 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		55: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		55: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"2":"vendor-amcharts~98821010","29":"vendor-pdf~20ed598d","30":"vendor-pdf~c73d5c0e","59":"vendors~canvg~253ae210"}[chunkId]||chunkId) + "." + {"2":"7c0ef0e0","3":"450fcf1c","4":"932d272c","5":"987d0909","6":"395f4347","7":"d483e2bb","22":"a0c81f2a","23":"a8ed755f","24":"1b8a95c8","25":"5a41c3b7","26":"1a39f427","27":"6ee4e95c","28":"750ad83e","29":"6a865939","30":"c8da9276","31":"e27c2909","32":"7ccb4d0c","33":"a80f0bf9","34":"8ce7cfd7","35":"460c2df9","36":"3e272679","37":"c4bab633","38":"0dfc1633","39":"db446bcd","40":"0296ad0c","59":"cfc9d2b9","60":"b826104a","61":"e24dbae7","62":"2e56304e","63":"32a63fb4","64":"2637b539","65":"f9a6005a","66":"8cf1cb2c","67":"b7177827","68":"d446de82","69":"8b3e045b","70":"46110f31","71":"005db17d","72":"a9bf6e59","73":"f04340b6","74":"5bc43b53","75":"07bc91c6","76":"f5635934","77":"fa03c86f","78":"6696b94c","79":"a0d333cf","80":"6a6c4dbb","81":"b0c4d5cd","82":"cac1031a","83":"b0d5f2a4","84":"45acb2ad","85":"3620c2e0","86":"31619a5e","87":"98d5baeb","88":"d15fc3e1","89":"00f69eca","90":"e6d20b40","91":"4466acc4","92":"e2bc1918","93":"17613dfd","94":"f41397d8","95":"7720b6f4","96":"ff5882f8","97":"076db62a","98":"5e470ccb","99":"8aa83e1d","100":"15c67f56","101":"d7c6beda","102":"7ce83251","103":"edf6ee8c","104":"1496706e","105":"b8eec434","106":"a5b3af25","107":"aafd068f","108":"c0f22175","109":"8ef70a2d","110":"086c70b8","111":"7fdd9d7a","112":"6bd9499f","113":"6b422742","114":"e312b676","115":"72319ad6","116":"657f4afd","117":"5bfde16c","118":"bce75856","119":"2aef427f","120":"2f95016c","121":"9699fc69","122":"ab3dc74f","123":"506facd1","124":"856d107f","125":"ca8fbeaa","126":"99211920","127":"5e26cdcf","128":"3b37529b","129":"5a5e65db","130":"e464ac3f","131":"5626c123","132":"370d56f2","133":"506e3dd5","134":"e45004fa","135":"320b5980","136":"cf865f7b","137":"e754b89b","138":"5535f571","139":"e89d13a7","140":"2411e672","141":"1cf3f8d9","142":"4cd7443f","143":"9a62c153","144":"6ac42bcb","145":"dec34eda","146":"e7baf575","147":"b2333f59","148":"d07d4b5d","149":"cc5f25fe","150":"664e7b40","151":"0a002cab","152":"4405a9fd","153":"f2e90afa","154":"05722042","155":"c48ec9d6","156":"30592d6a","157":"c936e98d","158":"30023d87","159":"7806bc25","160":"fddb4414","161":"6f605592","162":"ac9328b6","163":"d5915da1","164":"00508a4f","165":"d509557c","166":"403a3170","167":"7b94a207","168":"98c8a409","169":"f3c28e80","170":"9a89a0ef","171":"3391686d","172":"de4dc473","173":"5fbda1f8","174":"b326c148","175":"b985942a","176":"f2b3bce7","177":"095d7637","178":"6924e6db","179":"24e1aa5d","180":"a24477bc","181":"9a27d8df","182":"230570f9","183":"3f432127","184":"95c90dc1","185":"8d595d3c","186":"625f4b8c","187":"a156a5bc","188":"c90240bd","189":"eae7ff59","190":"e18de5f6","191":"9bb3fb7f","192":"003cc027","193":"2cc52d0f","194":"41551bd4","195":"0c467f73","196":"22760b53","197":"fba95e0c","198":"56d7a601","199":"1edf7d01","200":"7838a7e4","201":"060b4f15"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"6":1,"23":1,"24":1,"31":1,"32":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"104":1,"114":1,"115":1,"116":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"2":"vendor-amcharts~98821010","29":"vendor-pdf~20ed598d","30":"vendor-pdf~c73d5c0e","59":"vendors~canvg~253ae210"}[chunkId]||chunkId) + "." + {"2":"31d6cfe0","3":"f6763fa8","4":"31d6cfe0","5":"31d6cfe0","6":"b825bd60","7":"31d6cfe0","22":"31d6cfe0","23":"f1c83979","24":"e2466696","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"9fd3029e","32":"301334b3","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"48a261f5","63":"8f89cb31","64":"8f89cb31","65":"8f89cb31","66":"8f89cb31","67":"8f89cb31","68":"8f89cb31","69":"301334b3","70":"ddd8d16b","71":"f5070ea7","72":"8f89cb31","73":"8f89cb31","74":"301334b3","75":"301334b3","76":"caf108b9","77":"f5070ea7","78":"8f89cb31","79":"968145ee","80":"301334b3","81":"301334b3","82":"968145ee","83":"be01848b","84":"8f89cb31","85":"301334b3","86":"31d6cfe0","87":"1b3b5eac","88":"be01848b","89":"968145ee","90":"968145ee","91":"d58a115b","92":"968145ee","93":"968145ee","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"31d6cfe0","104":"d498bfb3","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"31d6cfe0","109":"31d6cfe0","110":"31d6cfe0","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"461b142c","115":"be01848b","116":"2e74bb64","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0","179":"31d6cfe0","180":"31d6cfe0","181":"31d6cfe0","182":"31d6cfe0","183":"31d6cfe0","184":"31d6cfe0","185":"31d6cfe0","186":"31d6cfe0","187":"31d6cfe0","188":"31d6cfe0","189":"31d6cfe0","190":"31d6cfe0","191":"31d6cfe0","192":"31d6cfe0","193":"31d6cfe0","194":"31d6cfe0","195":"31d6cfe0","196":"31d6cfe0","197":"31d6cfe0","198":"31d6cfe0","199":"31d6cfe0","200":"31d6cfe0","201":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpkristo"] = this["webpackJsonpkristo"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
